import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ThemeService } from '../../../services/theme.service';
import { EssayExecutionAirFiles } from '../../../model/essayProtocolAir';

export interface DialogDataEditAttachmentVideo {
  essayFile: EssayExecutionAirFiles;
}

@Component({
  selector: 'app-edit-attachment-video',
  templateUrl: './edit-attachment-video.component.html',
  styleUrls: ['./edit-attachment-video.component.scss'],
  standalone: false
})
export class EditAttachmentVideoComponent implements OnDestroy {

  private destroy$ = new Subject<void>();
  
  constructor( public dialogRef: MatDialogRef<EditAttachmentVideoComponent>,
      @Inject(MAT_DIALOG_DATA) public data: DialogDataEditAttachmentVideo,
      private themeService: ThemeService) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onOkClick(): void {
    this.dialogRef.close(this.data.essayFile);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }


}
